import ExampleCodeBlock, { CodeParamType } from '../../Docs/ExampleCodeBlock'
import { httpCodeExamples } from '../http-code-examples'

const js = `await integrationApp
  .integration('{INTEGRATION_KEY}')
  .getDataCollections()`

const rest = httpCodeExamples('/integrations/{INTEGRATION_KEY}/data')

export function ListDataCollectionsCodeExample() {
  return (
    <ExampleCodeBlock
      customCodes={{ js, ...rest }}
      parameters={{
        INTEGRATION_KEY: CodeParamType.IntegrationKey,
      }}
      run={async ({ integrationApp, parameters }) => {
        return await integrationApp
          .integration(parameters.INTEGRATION_KEY)
          .getDataCollections()
      }}
    />
  )
}
